import * as React from "react"
import Box from "@mui/material/Box"
import { SOCIAL_ITEMS_PROPS } from "../../constants/index"
import Social from "./social"
import Menu from "./menu"
import IconClose from "./closeicon"
import LogoWhite from "./logowhite"

const SlidingMenu = ({ onClick, isMenuVisible }) => {
  return (
    <header>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          width: "100vw",
          position: "fixed",
          left: 0,
          top: 0,
          opacity: 0.8,
          transform: "translateX(-100vw)",
          transition: "transform, opacity",
          transitionDuration: "1s, 1s",
          ...(isMenuVisible && {
            opacity: 1,
            transform: "translateX(0vw)",
          }),
          backgroundColor: "#000",
          overflow: "scroll",
          zIndex: 1000,
        }}
      >
        <Box
          my={3}
          mx={1}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <IconClose onClick={onClick} />
          <LogoWhite isMenuVisible={isMenuVisible} />
        </Box>

        <Box mt={15} ml={3}>
          <Menu isMenuVisible={isMenuVisible} itemVerticalSpace={50} />
        </Box>

        <Box
          mb={3}
          ml={3}
          sx={{
            position: "absolute",
            bottom: 0,
          }}
        >
          <Social data={SOCIAL_ITEMS_PROPS} label={"Meet me on social"} />
        </Box>
      </Box>
    </header>
  )
}

export default SlidingMenu
